<menu
  class="palantir-scrollbar duration-250 flex h-full flex-col overflow-x-hidden bg-white transition-all"
  [@menuState]="isCollapsed() ? 'collapsed' : 'expanded'"
>
  <header class="flex h-16 items-center gap-2.5 self-stretch border-b px-4 py-3">
    @if (!isCollapsed()) {
      <img src="assets/logo/flux-logo.png" [alt]="'Flux Control'" />
    }

    <palantir-button
      (click)="sidebarService.toggleCollapse()"
      class="ml-auto"
      theme="transparent"
      variant="neutral"
      layout="icon"
      icon="dock-to-right-outline"
    ></palantir-button>
  </header>

  <main class="palantir-scrollbar flex-auto">
    <section class="flex h-full flex-col px-3 py-4">
      <div class="mt-6 flex flex-auto flex-col">
        <!-- Top align content -->

        <div class="flex flex-auto flex-col content-start">
          @for (item of itemsAligned('top'); track $index) {
            <ng-container *hasPermission="item.required_permissions ?? []">
              <ng-container *featureFlag="item.has_feature_flag ?? []">
                @if (isCollapsed()) {
                  <palantir-avatar
                    class="relative mb-2 cursor-pointer rounded-md [&>.palantir-avatar]:bg-transparent"
                    routerLinkActive="menu-item-active"
                    [routerLink]="item.url"
                    shape="thumbnail"
                    size="2xs"
                    routerLink="{{ item.url }}"
                  >
                    @if (item.url === 'notificacoes' && notificationsCount() > 0) {
                      <div class="absolute right-1 top-1 size-2 rounded-full bg-blue-50"></div>
                    }

                    @if (item.url === 'meu-espaco' && mySpaceBadgesService.hasUnreadBadges()) {
                      <div class="absolute right-1 top-1 size-2 rounded-full bg-blue-50"></div>
                    }

                    <palantir-icon [name]="item.icon" />
                  </palantir-avatar>
                } @else {
                  <a
                    [routerLink]="item.url"
                    routerLinkActive="menu-item-active"
                    class="flex items-center gap-2 rounded-lg p-2.5 text-black transition-all hover:text-flux-blue-500"
                  >
                    <palantir-icon class="text-current" [name]="item.icon"></palantir-icon>

                    <palantir-text class="truncate font-medium text-current">
                      {{ item.label }}
                    </palantir-text>

                    @if (item.url === 'notificacoes' && notificationsCount() > 0) {
                      <div
                        class="ml-auto flex items-center justify-center rounded-xl bg-blue-50 px-1"
                      >
                        <palantir-text class="pt-0.5 text-[10px] text-white">
                          {{ notificationsCount() }}
                        </palantir-text>
                      </div>
                    }

                    @if (item.url === 'meu-espaco' && mySpaceBadgesService.hasUnreadBadges()) {
                      <div
                        class="ml-auto flex items-center justify-center rounded-xl bg-blue-50 px-1"
                      ></div>
                    }
                  </a>
                }
              </ng-container>
            </ng-container>
          }
        </div>

        <!-- Bottom align content -->

        <div class="flex flex-col content-end">
          @for (item of itemsAligned('bottom'); track $index) {
            <ng-container *hasPermission="item.required_permissions ?? []">
              <ng-container *featureFlag="item.has_feature_flag ?? []">
                @if (isCollapsed()) {
                  <palantir-avatar
                    class="mb-2 cursor-pointer rounded-md [&>.palantir-avatar]:bg-transparent"
                    routerLinkActive="menu-item-active"
                    [routerLink]="item.url"
                    shape="thumbnail"
                    size="2xs"
                    routerLink="{{ item.url }}"
                  >
                    <palantir-icon [name]="item.icon" />
                  </palantir-avatar>
                } @else {
                  <a
                    [routerLink]="item.url"
                    routerLinkActive="menu-item-active"
                    class="flex items-center gap-2 rounded-lg p-2.5 transition-all hover:text-flux-blue-500"
                  >
                    <palantir-icon class="text-current" [name]="item.icon"></palantir-icon>

                    <palantir-text class="truncate font-medium text-current">
                      {{ item.label }}
                    </palantir-text>
                  </a>
                }
              </ng-container>
            </ng-container>
          }
        </div>
      </div>
    </section>

    <section></section>
  </main>

  <footer class="flex items-center justify-center gap-2.5 border-t p-4">
    @if (user()) {
      <div class="h-8 w-8 overflow-hidden rounded-full object-cover">
        <palantir-avatar [fallbackText]="user()!.name">
          @if (user()!.avatarUrl) {
            <img [src]="user()!.avatarUrl" [alt]="user()!.name" />
          } @else {
            {{ user()!.name }}
          }
        </palantir-avatar>
      </div>
    }

    <div class="flex flex-auto flex-col" *ngIf="!isCollapsed()">
      <palantir-text type="title" class="max-w-[150px] truncate text-[12px] leading-none">
        {{ user()?.name }}
      </palantir-text>

      <palantir-text type="subtitle" size="2xs" class="truncate text-wrap">
        {{ user()?.email }}
      </palantir-text>
    </div>

    <palantir-button
      *ngIf="!isCollapsed()"
      class="flex-auto"
      theme="transparent"
      variant="neutral"
      layout="icon"
      [cdkMenuTriggerFor]="menuState"
      icon="more-horizontal-outline"
    ></palantir-button>
  </footer>
</menu>

<ng-template #menuState>
  <div class="bg-white px-2 py-3">
    <palantir-button
      (click)="onLogout()"
      class="ml-auto"
      theme="transparent"
      variant="negative"
      layout="prefix"
      icon="logout-outline"
    >
      Sair
    </palantir-button>
  </div>
</ng-template>
